import styled from 'styled-components'
import { theme } from '../../../../styles/theme'
import { orderColors, orderLightColors } from '../../../../helpers/helper-order'
import { OrderStatus } from '../../../../enums/order.enum'

interface IOrderInfoHeader {
  code: OrderStatus;
}

export const Container = styled.div`
  width: 100%;
  margin: 24px 0px;
  overflow: hidden;
  overflow-y: auto;

  background: ${theme.colors.mainBg};
  border-radius: ${theme.border.normal};
  filter: drop-shadow(0px 6px 15px rgba(37, 42, 49, 0.1));

  & > table {
    width: 100%;
    border-collapse: collapse;

    & td,
    & th {
      text-align: left;
      padding: 12px;
      border: 1px solid #E0E0E0;
      border-bottom-color: #BDBDBD;
    }

    & > thead {
      background-color: ${theme.colors.brown};
      & > tr > th {
        font-family: ${theme.font.inter};
        font-weight: ${theme.font.semiBold};
        font-size: ${theme.font.sizes.xxsmall};
        line-height: ${theme.font.sizes.xsmall};
        color: ${theme.colors.mainBg};
      }
    }

    & > tbody > tr > td {
      font-family: ${theme.font.inter};
      font-weight: ${theme.font.normal};
      font-size: ${theme.font.sizes.small};
      line-height: ${theme.font.sizes.normal};
      color: ${theme.colors.black};

      &.price {
        font-size: ${theme.font.sizes.large};
        line-height: ${theme.font.sizes.xlarge};
        color: ${theme.colors.brown};
      }

      & > ul {
        margin-left: 20px;
      }
    }
  }
`

export const OrderStatusCard = styled.div`
  width: 100%;
  margin: 24px 0px;
  overflow: hidden;

  background: ${theme.colors.mainBg};
  border-radius: ${theme.border.normal};

  & > div {
    width: 100%;
    padding: 8px 22px 22px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const PaymentMethods = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
`

export const OrderStatusHeader = styled.header<IOrderInfoHeader>`
  width: 100%;
  padding: 8px 22px;

  background: ${({ code }) => orderLightColors[code]};

  & > h2 {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.medium};
    line-height: ${theme.font.sizes.large};
    color: ${({ code }) => orderColors[code]};
  }
`

export const PaymentInfo = styled.div`
  padding: 9px 12px;

  display: flex;
  align-items: center;
  gap: 23px;

  background: #FBFAFC;
  border: 1px solid #F5F5F5;

  & > div {
    & > p {
      font-family: ${theme.font.inter};
      font-weight: ${theme.font.semiBold};
      font-size: ${theme.font.sizes.small};
      line-height: ${theme.font.sizes.normal};
      color: ${theme.colors.black};
    }

    & > span {
      font-family: ${theme.font.inter};
      font-weight: ${theme.font.semiBold};
      font-size: ${theme.font.sizes.xxsmall};
      line-height: ${theme.font.sizes.xsmall};
      color: ${theme.colors.black};
    }
  }
`

export const CardType = styled.div`
  width: 48px;
  height: 47px;

  border: 1px solid ${theme.colors.gray};
  border-radius: ${theme.border.smallRadius};

  display: flex;
  align-items: center;
  justify-content: center;

  & > img {
    object-fit: contain;
    width: 90%;
  }
`

export const OrderInfoFooter = styled.div`
  margin: 52px 19px 12px;

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  & > p {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.large};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.brown};

    & > strong {
      margin-right: 18px;

      font-weight: ${theme.font.medium};
    }
  }

  & > span {
    margin-top: 10px;

    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xxsmall};
    line-height: ${theme.font.sizes.xsmall};
    color: ${theme.colors.redLight};
  }
`

export const Total = styled.div`
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.xlarge};
  line-height: ${theme.font.sizes.xxlarge};
  color: ${theme.colors.brown};

  & > strong {
    margin-right: 18px;

    font-weight: ${theme.font.medium};
  }
`

export const TaxWrapper = styled.div`
  margin-bottom: 18px;

  display: flex;
  align-items: center;
  gap: 15px;

  & > p {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.medium};
    line-height: ${theme.font.sizes.large};
    color: ${theme.colors.brown};

    & > em {
      margin-left: 20px;
      font-style: normal;
    }
  }

  & > button {
    padding: 12px 10px;

    background: #F2994A;
    box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
    border-radius: ${theme.border.smallRadius};
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xsmall};
    line-height: ${theme.font.sizes.small};
    color: ${theme.colors.mainBg};
  }
`
